module.exports = __webpack_public_path__ + "static/media/banner.d0c54f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/banner.png
// module id = 642
// module chunks = 0